import React, { createContext, useContext, useState, useCallback } from "react";

const SidebarContext = createContext({
    isOpen: false,
    toggle: () => {},
    close: () => {},
});

export function SidebarProvider({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    const close = useCallback(() => setIsOpen(false), []);

    return (
        <SidebarContext.Provider value={{ isOpen, toggle, close }}>
            {children}
        </SidebarContext.Provider>
    );
}

export function useSidebar() {
    return useContext(SidebarContext);
}
